import { render, staticRenderFns } from "./OperaterStatic.vue?vue&type=template&id=22a07c4c&scoped=true&"
import script from "./OperaterStatic.vue?vue&type=script&lang=js&"
export * from "./OperaterStatic.vue?vue&type=script&lang=js&"
import style0 from "./OperaterStatic.vue?vue&type=style&index=0&id=22a07c4c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a07c4c",
  null
  
)

export default component.exports